const easyrecApiUrl = 'https://www.paperculture.com/easyrec/api/1.1/json/'

const apiKey = '13f99b671fc70802b81321528b41a424'
const tenantId = 'paperculture'

const defaults = {
  drawingCallback: 'drawRecommendationList',
  actionCallback: 'void',
  userId: null,
  itemId: '-1',
  sessionId: getSessionId(),
  itemUrl: '',
  itemDescription: '',
  itemImageUrl: '',
  timeRange: 'ALL',
  numberOfResults: 10,
  actionTime: null,
  strategy: 'NEWEST',
  useFallback: false,
  itemType: 'ITEM',
  requestedItemType: 'ITEM',
  clusterId: null,
  basedOnActionType: 'VIEW'
}

// Item actions

const sendAction = function (actionType, options) {
  const o = extend(options, defaults)

  if (actionType !== 'buy' && actionType !== 'view' && actionType !== 'rate') {
    o.actionType = actionType
    actionType = 'sendaction'
  }

  includeImage(
    easyrecApiUrl +
      actionType +
      '?' +
      'tenantid=' +
      tenantId +
      '&apikey=' +
      apiKey +
      (o.userId ? '&userid=' + o.userId : '') +
      '&itemid=' +
      o.itemId +
      '&sessionid=' +
      o.sessionId +
      '&itemurl=' +
      encodeURIComponent(o.itemUrl) +
      '&itemdescription=' +
      encodeURIComponent(o.itemDescription) +
      '&itemimageurl=' +
      encodeURIComponent(o.itemImageUrl) +
      '&ratingvalue=' +
      o.ratingValue +
      '&callback=' +
      o.actionCallback +
      '&itemtype=' +
      o.itemType +
      (o.actionType ? '&actiontype=' + o.actionType : '') +
      (o.actionValue ? '&actionvalue=' + o.actionValue : '') +
      (o.actionTime ? '&actiontime=' + o.actionTime : '')
  )
}

// Tracks if a user purchases a specific item
const buy = function (options) {
  sendAction('buy', options)
}

// Tracks if a user views a specific item
const view = function (options) {
  sendAction('view', options)
}

// Tracks if a user rates a specific item
const rate = function (options) {
  sendAction('rate', options)
}

// Calls the recommender to retrieve a list of recommendations
const getRecommendations = function (recommendationType, options) {
  const o = extend(options, defaults)
  includeJavascript(
    easyrecApiUrl +
      recommendationType +
      '?' +
      'tenantid=' +
      tenantId +
      '&apikey=' +
      apiKey +
      (o.userId ? '&userid=' + o.userId : '') +
      '&itemid=' +
      o.itemId +
      '&itemtype=' +
      o.itemType +
      '&requesteditemtype=' +
      o.requestedItemType +
      '&actiontype=' +
      o.basedOnActionType +
      '&callback=' +
      o.drawingCallback +
      '&numberOfResults=' +
      o.numberOfResults +
      (o.assocType ? '&assoctype=' + o.assocType : '')
  )
}

const otherUsersAlsoViewed = function (options) {
  getRecommendations('otherusersalsoviewed', options)
}

const otherUsersAlsoBought = function (options) {
  getRecommendations('otherusersalsobought', options)
}

const itemsRatedGoodByOtherUsers = function (options) {
  getRecommendations('itemsratedgoodbyotherusers', options)
}

const recommendationsForUser = function (options) {
  getRecommendations('recommendationsforuser', options)
}

const relatedItems = function (options) {
  getRecommendations('relateditems', options)
}

const actionHistoryForUser = function (options) {
  getRecommendations('actionhistoryforuser', options)
}

// Ranking functions

// For all Ranking functions:
//   - Allowed values for timeRange are: DAY, WEEK, MONTH, ALL
//   - The functions retrieve the daily, weekly, monthly or all time most acted on items

const getRankings = function (rankingType, options) {
  const o = extend(options, defaults)

  includeJavascript(
    easyrecApiUrl +
      rankingType +
      '?' +
      'tenantid=' +
      tenantId +
      '&apikey=' +
      apiKey +
      '&timeRange=' +
      o.timeRange +
      '&numberOfResults=' +
      o.numberOfResults +
      '&requesteditemtype=' +
      o.requestedItemType +
      '&callback=' +
      o.drawingCallback
  )
}

const mostViewedItems = function (options) {
  getRankings('mostvieweditems', options)
}

const mostBoughtItems = function (options) {
  getRankings('mostboughtitems', options)
}

const mostRatedItems = function (options) {
  getRankings('mostrateditems', options)
}

const bestRatedItems = function (options) {
  getRankings('bestrateditems', options)
}

const worstRatedItems = function (options) {
  getRankings('worstrateditems', options)
}

const itemsInCluster = function (options) {
  const o = extend(options, defaults)

  includeJavascript(
    easyrecApiUrl +
      'itemsincluster?' +
      'tenantId=' +
      tenantId +
      '&apikey=' +
      apiKey +
      '&clusterId=' +
      o.clusterId +
      '&strategy=' +
      o.strategy +
      '&useFallback=' +
      o.useFallback +
      '&numberOfResults=' +
      o.numberOfResults +
      '&requesteditemtype=' +
      o.requestedItemType +
      '&callback' +
      o.drawingCallback
  )
}

const cluster = function (options) {
  const o = extend(options, defaults)

  includeJavascript(
    easyrecApiUrl +
      'clusters?' +
      'tenantId=' +
      tenantId +
      '&apikey=' +
      apiKey +
      '&callback' +
      o.drawingCallback
  )
}

const itemTypes = function (options) {
  const o = extend(options, defaults)

  includeJavascript(
    easyrecApiUrl +
      'itemtypes?' +
      'tenantId=' +
      tenantId +
      '&apikey=' +
      apiKey +
      '&callback' +
      o.drawingCallback
  )
}

// Recommendation drawing callback

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
function drawRecommendationList(json) {
  drawRecommendationListToDiv(json, 'recommenderDiv')
}

function drawRecommendationListToDiv(json, recommenderDiv) {
  if ('undefined' === typeof json.error) {
    // if no error show recommendations

    try {
      // eslint-disable-next-line no-var -- FIXME
      var items = json.recommendeditems.item
    } catch (e) {
      return
    }

    // When the object is already in array format, this block will not execute
    if ('undefined' === typeof items.length) {
      items = new Array(items)
    }

    // Display recommendations in the DIV layer 'recommendation'
    if (items.length > 0) {
      let listString = '<ul>'

      // eslint-disable-next-line no-undef -- FIXME
      for (x = 0; x < items.length; x++) {
        listString +=
          '<li><a href="' +
          // eslint-disable-next-line no-undef -- FIXME
          items[x].url +
          '">' +
          // eslint-disable-next-line no-undef -- FIXME
          items[x].description +
          '</a>' +
          '</li>'
      }
      document.getElementById(recommenderDiv).innerHTML += listString + '</ul>'
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
function drawRecommendationListWithPictures(json) {
  drawRecommendationListWithPicturesToDiv(json, 'recommenderDiv')
}

function drawRecommendationListWithPicturesToDiv(json, recommenderDiv) {
  if ('undefined' === typeof json.error) {
    // if no error show recommendations

    try {
      // eslint-disable-next-line no-var -- FIXME
      var items = json.recommendeditems.item
    } catch (e) {
      return
    }

    /* when the object is already in array format, this block will not execute */
    if ('undefined' === typeof items.length) {
      items = new Array(items)
    }

    // display recommendations in the DIV layer 'recommendation'
    if (items.length > 0) {
      for (let x = 0; x < items.length; x++) {
        document.getElementById(recommenderDiv).innerHTML +=
          '<div style="width:170px;padding:5px;float:left;text-align:center;">' +
          '<a href="' +
          items[x].url +
          '">' +
          '<img style="width:150px;border:0px;" alt="' +
          items[x].description +
          '"' +
          ' src="' +
          items[x].imageUrl +
          '"/><br/>' +
          items[x].description +
          '</a>' +
          '</div>'
      }
    }
  }
}

// JavaScript helpers

// Creates a new <script> tag with the given address as the source
function includeJavascript(jsAdr) {
  const newJs = document.createElement('script')
  newJs.src = jsAdr
  document.getElementsByTagName('head')[0].appendChild(newJs)
}

function includeImage(imgSrc) {
  const img = new Image()
  img.src = imgSrc
}

function extend(options, defaults) {
  const target = options

  for (const propertyName in defaults) {
    const src = target[propertyName]
    const copy = defaults[propertyName]

    if (src != null) {
      continue
    } else if (copy !== undefined) {
      target[propertyName] = copy
    }
  }
  // Return the modified object
  return target
}

// Session functions
function createSessionId() {
  const name = 'easyrec_sessionVar'
  const value = generateSessionId(15)
  String(new Date().getTime()).replace(/\D/gi, '')
  document.cookie = name + '=' + value + '; path=/'
  return value
}

function generateSessionId(length) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
  let returnValue = ''

  for (let x = 0; x < length; x++) {
    const i = Math.floor(Math.random() * 62)
    returnValue += chars.charAt(i)
  }

  return 'JS_' + returnValue
}

function getSessionId() {
  const nameEQ = 'easyrec_sessionVar='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length)
    }
  }
  return createSessionId()
}
// TODO: Tree shake or remove unused code since most of this is unused
export default {
  sendAction,
  buy,
  view,
  rate,
  getRecommendations,
  otherUsersAlsoViewed,
  otherUsersAlsoBought,
  itemsRatedGoodByOtherUsers,
  recommendationsForUser,
  relatedItems,
  actionHistoryForUser,
  getRankings,
  mostViewedItems,
  mostBoughtItems,
  mostRatedItems,
  bestRatedItems,
  worstRatedItems,
  itemsInCluster,
  cluster,
  itemTypes
}
